var spoiler_default = {
  "fontElementMap": "_--9cR",
  "hideText": "-GAbG",
  "onHoverText": "Mb0Td",
  "hideBlock": "C12ao",
  "smallBlur": "_56nyR",
  "mediumBlur": "_2zq--",
  "largeBlur": "_75sDc",
  "hideBlock_gallery": "GLiLi",
  "overlay": "Y5LsH",
  "overlay_gallery": "Tj4Ha",
  "revealSpoilerBtn": "o8kKg",
  "isMobile": "ftcMj",
  "onHoverBtn": "aYrPJ",
  "spoilerWrapper": "viRP0",
  "spoilerDescription": "TZ-U6",
  "spoilerContainer": "_-91QI",
  "spoilerContainer_Gallery": "k4E5y"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
